module.exports = __webpack_public_path__ + "static/media/aluWall2.6e76ce30.jpeg";